type Scope = 'workspace' | 'personal' | 'mixed';

interface Props {
  scope: Scope;
}

const SCOPE_META: Record<Scope, { label: string; color: string; bg: string }> = {
  workspace: { label: 'Workspace-wide', color: 'var(--info)',         bg: 'rgba(13,148,136,.10)' },
  personal:  { label: 'Personal only',  color: 'var(--priv-private)', bg: 'rgba(45,0,247,.08)'   },
  mixed:     { label: 'Mixed',          color: 'var(--priv-team)',    bg: 'rgba(217,119,6,.10)'  },
};

export function ScopePill({ scope }: Props) {
  const meta = SCOPE_META[scope] ?? SCOPE_META.mixed;
  return (
    <span
      className="chip"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 20,
        padding: '0 8px',
        borderRadius: 'var(--radius-full)',
        background: meta.bg,
        color: meta.color,
        fontSize: 10.5,
        fontWeight: 600,
        letterSpacing: '0.02em',
      }}
    >
      {meta.label}
    </span>
  );
}
